import React from 'react';
import { Link } from 'react-router-dom';
import { clsx } from 'clsx';
import { Button } from '../ui';
import { useTheme } from '../../contexts/ThemeContext';

interface HeaderProps {
  className?: string;
  actions?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({
  className,
  actions,
}) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header
      className={clsx(
        'h-14 lg:h-16 bg-card/85 backdrop-blur-xl border-b border-border/80',
        'flex items-center justify-between px-4 lg:px-6',
        'sticky top-0 z-50',
        'transition-all duration-200 ease-out',
        'shadow-xs',
        className
      )}
    >
      <div className="flex items-center gap-3 lg:gap-4">
        <Link
          to="/dashboard"
          aria-label="대시보드로 이동"
          className="relative shrink-0 w-14 h-10 lg:w-16 lg:h-12 overflow-hidden rounded-xl"
        >
          <img src="/1004logo.png" alt="1004보금자리 로고" className="w-full h-full object-contain" />
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/90 to-transparent mix-blend-overlay animate-logo-shine"
          />
        </Link>
      </div>

      <div className="flex items-center gap-2 lg:gap-3">
        {/* Custom Actions (사용자 정보, 설정, 로그아웃 등) */}
        {actions}

        {/* 구분선 */}
        {actions && (
          <div className="h-4 lg:h-5 w-px bg-border/80 mx-1" />
        )}

        {/* Theme Toggle Button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleTheme}
          className="p-2 hover:bg-secondary hover:text-primary transition-all rounded-xl border border-transparent hover:border-border/60"
          title={`${theme === 'light' ? '다크' : '라이트'} 모드로 전환`}
        >
          {theme === 'light' ? (
            // Moon icon for dark mode
            <svg className="w-4 h-4 lg:w-5 lg:h-5 text-muted-foreground hover:text-indigo-600 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          ) : (
            // Sun icon for light mode
            <svg className="w-4 h-4 lg:w-5 lg:h-5 text-amber-400 hover:text-amber-300 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          )}
        </Button>
      </div>
    </header>
  );
};